module.exports = __webpack_public_path__ + "img/review-banner.jpg";